export default __webpack_public_path__ + "static/broadcastImg3-5a7b249f10df40bbefc7c1044349f169.webp";